import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { useBedrockRegistration } from 'store/bedrockRegistration';
import { useVertical } from 'lib/Hooks';
import { publisherNameMap } from 'lib/vertical';
import { Checkbox } from 'components/FormFields/Checkbox';
import { ErrorMsg } from 'components/FormFields/ErrorMsg';
import { Description } from 'components/FormFields/Description';
import { TermsAndConditions } from 'components/AccountLoginRegistration/TermsAndConditions';
import { SubmitButton } from 'components/FormFields/SubmitButton';
import { termsAndConditionsSchema } from '../validationSchema';

import styles from './styles.module.scss';

/**
 * Renders the Social Registration screen.
 * @returns {React.ReactElement} The rendered component.
 */
const SocialRegistrationScreen = () => {
  const userSocialRegistration = useBedrockRegistration((state) => state.userSocialRegistration);
  const setScreen = useBedrockRegistration((state) => state.setScreen);
  const error = useBedrockRegistration((state) => state.error);
  const { vertical } = useVertical();
  const brand = publisherNameMap[vertical];

  const methods = useForm({
    resolver: yupResolver(termsAndConditionsSchema),
  });

  /**
   * Handles form submission for social registration.
   */
  const onSubmit = () => {
    const trackingPayload = {
      action: 'SignIn:Submit',
      method: 'SubmitButtonClick',
    };
    userSocialRegistration({ trackingPayload, brand }).then((result) => {
      // update the screen value based on the response
      if (result) {
        setScreen(result);
      }
    });
  };

  return (
    <>
      <h2>Before we get started...</h2>
      <ErrorMsg message={error} />
      <Description className={styles.dek}>
        Just a quick check to make sure you&apos;re on board with our terms and conditions.
      </Description>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(onSubmit)}
          data-testid="account-social-registration"
        >
          <Checkbox name="termsAndConditions" dataTestId="terms-checkbox" isRequired>
            <TermsAndConditions />
          </Checkbox>
          <SubmitButton
            title="Create Account"
          />
        </form>
      </FormProvider>
    </>
  );
};

export { SocialRegistrationScreen };
